import { NavLink } from "react-router-dom";

export default function SharingTabs() {
  return (
    <nav className="mb-6 flex gap-1 border-b border-slate-200" aria-label="Sharing sections">
      <Tab to="/sharing/office-files">KraetdNet Office Files</Tab>
      <Tab to="/sharing/folders">Folders</Tab>
      <Tab to="/sharing/printers">Printers</Tab>
      <Tab to="/sharing/scanners">Scanners</Tab>
      <Tab to="/sharing/send">Send a file</Tab>
    </nav>
  );
}

function Tab({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) =>
        `border-b-2 px-4 py-2 text-sm font-medium ${
          isActive
            ? "border-slate-900 text-slate-900"
            : "border-transparent text-slate-500 hover:text-slate-900"
        }`
      }
    >
      {children}
    </NavLink>
  );
}
